import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-news-feed',
  templateUrl: './news-feed.component.html',
  styleUrls: ['./news-feed.component.scss']
})
export class NewsFeedComponent implements OnInit {

  @Input() width: string = "215px";
  @Input() height: string = "350px";
  src: string;

  constructor() {
    let rssfeed_url = [];
    rssfeed_url[0]="http://feeds.reuters.com/reuters/businessNews";
    const rssfeed_width=this.width;
    const rssfeed_height=this.height;
    const rssfeed_scroll="on";
    const rssfeed_scroll_step="10";
    const rssfeed_scroll_bar="off";
    const rssfeed_target="_blank";
    const rssfeed_font_size="12";
    const rssfeed_font_face="Helvetica Neue";
    const rssfeed_border="off";
    const rssfeed_css_url="";
    const rssfeed_title="on";
    const rssfeed_title_name="Reuters News";
    const rssfeed_title_bgcolor="";
    const rssfeed_title_color="#999";
    const rssfeed_title_bgimage="";
    const rssfeed_footer="off";
    const rssfeed_footer_name="";
    const rssfeed_footer_bgcolor="";
    const rssfeed_footer_color="";
    const rssfeed_footer_bgimage="";
    const rssfeed_item_title_length="50";
    const rssfeed_item_title_color="rgb(94,187,75)";
    const rssfeed_item_bgcolor="#000";
    const rssfeed_item_bgimage="";
    const rssfeed_item_border_bottom="off";
    const rssfeed_item_source_icon="off";
    const rssfeed_item_date="off";
    const rssfeed_item_description="on";
    const rssfeed_item_description_length="120";
    const rssfeed_item_description_color="#999";
    const rssfeed_item_description_link_color="#333";
    const rssfeed_item_description_tag="off";
    const rssfeed_no_items="0";
    const rssfeed_cache = "07c2079abef1f6cf01830eac6b0337f0";

    let urls="";
    for(let i=0; i<rssfeed_url.length; i++) {
      urls = urls+"rssfeed[url]["+i+"]="+encodeURIComponent(rssfeed_url[i])+"&";
    }

    const protocol: string = "https";
    let srcTmp = ("https:"==protocol?"https":"http")+"://feed.surfing-waves.com/php/rssfeed.php"+"?"+urls
    srcTmp += "rssfeed[type]=&rssfeed[frame_width]="+rssfeed_width+"&";
    srcTmp += "rssfeed[frame_height]="+rssfeed_height+"&";
    srcTmp += "rssfeed[scroll]="+(rssfeed_scroll?rssfeed_scroll:"")+"&";
    srcTmp += "rssfeed[scroll_step]="+(rssfeed_scroll_step?rssfeed_scroll_step:"")+"&";
    srcTmp += "rssfeed[scroll_bar]="+(rssfeed_scroll_bar?rssfeed_scroll_bar:"")+"&";
    srcTmp += "rssfeed[target]="+(rssfeed_target?rssfeed_target:"")+"&";
    srcTmp += "rssfeed[font_size]="+(rssfeed_font_size?rssfeed_font_size:"")+"&";
    srcTmp += "rssfeed[font_face]="+(rssfeed_font_face?rssfeed_font_face:"")+"&";
    srcTmp += "rssfeed[border]="+(rssfeed_border?rssfeed_border:"")+"&";
    srcTmp += "rssfeed[css_url]="+(rssfeed_css_url?encodeURIComponent(rssfeed_css_url):"")+"&";
    srcTmp += "rssfeed[title]="+(rssfeed_title?rssfeed_title:"")+"&";
    srcTmp += "rssfeed[title_name]="+(rssfeed_title_name?encodeURIComponent(rssfeed_title_name):"")+"&";
    srcTmp += "rssfeed[title_bgcolor]="+(rssfeed_title_bgcolor?encodeURIComponent(rssfeed_title_bgcolor):"")+"&";
    srcTmp += "rssfeed[title_color]="+(rssfeed_title_color?encodeURIComponent(rssfeed_title_color):"")+"&";
    srcTmp += "rssfeed[title_bgimage]="+(rssfeed_title_bgimage?encodeURIComponent(rssfeed_title_bgimage):"")+"&";
    srcTmp += "rssfeed[footer]="+(rssfeed_footer?rssfeed_footer:"")+"&";
    srcTmp += "rssfeed[footer_name]="+(rssfeed_footer_name?encodeURIComponent(rssfeed_footer_name):"")+"&";
    srcTmp += "rssfeed[footer_bgcolor]="+(rssfeed_footer_bgcolor?encodeURIComponent(rssfeed_footer_bgcolor):"")+"&";
    srcTmp += "rssfeed[footer_color]="+(rssfeed_footer_color?encodeURIComponent(rssfeed_footer_color):"")+"&";
    srcTmp += "rssfeed[footer_bgimage]="+(rssfeed_footer_bgimage?encodeURIComponent(rssfeed_footer_bgimage):"")+"&";
    srcTmp += "rssfeed[item_bgcolor]="+(rssfeed_item_bgcolor?encodeURIComponent(rssfeed_item_bgcolor):"")+"&";
    srcTmp += "rssfeed[item_bgimage]="+(rssfeed_item_bgimage?encodeURIComponent(rssfeed_item_bgimage):"")+"&";
    srcTmp += "rssfeed[item_title_length]="+(rssfeed_item_title_length?rssfeed_item_title_length:"")+"&";
    srcTmp += "rssfeed[item_title_color]="+(rssfeed_item_title_color?encodeURIComponent(rssfeed_item_title_color):"")+"&";
    srcTmp += "rssfeed[item_border_bottom]="+(rssfeed_item_border_bottom?rssfeed_item_border_bottom:"")+"&";
    srcTmp += "rssfeed[item_source_icon]="+(rssfeed_item_source_icon?rssfeed_item_source_icon:"")+"&";
    srcTmp += "rssfeed[item_date]="+(rssfeed_item_date?rssfeed_item_date:"")+"&";
    srcTmp += "rssfeed[item_description]="+(rssfeed_item_description?rssfeed_item_description:"")+"&";
    srcTmp += "rssfeed[item_description_length]="+(rssfeed_item_description_length?rssfeed_item_description_length:"")+"&";
    srcTmp += "rssfeed[item_description_color]="+(rssfeed_item_description_color?encodeURIComponent(rssfeed_item_description_color):"")+"&";
    srcTmp += "rssfeed[item_description_link_color]="+(rssfeed_item_description_link_color?encodeURIComponent(rssfeed_item_description_link_color):"")+"&";
    srcTmp += "rssfeed[item_description_tag]="+(rssfeed_item_description_tag?rssfeed_item_description_tag:"")+"&";
    srcTmp += "rssfeed[no_items]="+(rssfeed_no_items?rssfeed_no_items:"")+"&";
    srcTmp += "rssfeed[cache]="+(rssfeed_cache?rssfeed_cache:"");

    this.src = srcTmp;
  }

  ngOnInit(): void {
  }

}
